'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('jobsDesktopController', function (jobService, orderService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
    mixpanel.track("Opened Jobs Desktop");

    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.itemEdit = null;
    $scope.showFilters = false;
    $scope.preventReloadWithFilters = true;
    $scope.selected = [];
    $scope.jobsSearch = "";
    $scope.allUsers = [];
    $scope.allocationUsers = [];
    $scope.jobAllocationsByUser = {};
    $scope.hasJobs = true
    $scope.myDocketbook = $state.params.myDocketbook
    $scope.customTemplate = [
      {
        name: 'Last 12 Months',
        dateStart: moment().subtract(12, 'months').toDate(),
        dateEnd: moment().toDate(),
      }
    ]

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    var statusFilterOptions = ['draft', 'sent', 'closed'];
    var assigneeStatusFilterOptions = ['assigned', 'accepted', 'rejected'];


    jobService.getJobs({ limit: 1, offset: 0 }, function (returnData) {
      $scope.hasJobs = returnData.length > 0
    })


    $scope.getStatus = function (item) {
      if (item == null) {
        return ""
      }

      /*if ( userService.userCanDoAction('assignUserToJob', item) && item && item.assignees && item.assignees.map(a => a.status.toLowerCase() != 'rejected').length == 0 ) {
        return "Unassigned"
      } else {*/
      return item.status
      //}
    }

    // Filters initial
    $scope.filters = {};
    $scope.filters.status = 'All';
    $scope.filters.startDate = moment().subtract(7, 'days').toDate(); //startToDate
    $scope.filters.endDate = moment().toDate(); //endFromDate
    $scope.startWeek = moment($scope.filters.startDate);
    $scope.filters.customer = 'All';
    $scope.filters.assignee = 'All';
    $scope.filters.assigneeList = [];
    $scope.filters.forwarder = null;
    $scope.filters.hasRejections = false;
    $scope.filters.viewType = 'list';
    $scope.filters.statusOptions = { allView: true, all: true, draft: true, sent: true, closed: true };
    $scope.filters.assigneeStatusOptions = { allView: true, all: true, assigned: true, accepted: true, rejected: true };
    $scope.filterHeading = "";
    $scope.activeFilters = 0;
    $scope.dateFilterModel = { dateStart: $scope.filters.startDate, dateEnd: $scope.filters.endDate, showTemplate: true };
    if ($scope.currentOrg && $scope.currentOrgGroup) {
      $scope.filters.organisationId = $scope.currentOrg.id;
      $scope.filters.groupId = $scope.currentOrgGroup.id;
    }

    // Default query pagination
    $scope.query = {
      limit: 30,
      page: 1,
      order: 'jobNumber'
    };
    $scope.promise = null;

    $scope.$watch('filters.startDate', function (before, after) {
      $scope.startWeek = moment($scope.filters.startDate);
    }, true);

    $scope.$watch('dateFilterModel.dateStart', function (before, after) {
      if ($scope.dateFilterModel.dateStart) {
        $scope.filters.startDate = $scope.dateFilterModel.dateStart;
      }
      if (!$scope.preventReloadWithFilters) {
        if (moment(after).diff(moment(before), 'days') != 0) {
          $scope.filtersChanged('date selector');
        }
      }
    }, true);

    $scope.$watch('dateFilterModel.dateEnd', function (before, after) {
      if ($scope.dateFilterModel.dateEnd) {
        $scope.filters.endDate = $scope.dateFilterModel.dateEnd;
      }
      if (!$scope.preventReloadWithFilters) {
        if (moment(after).diff(moment(before), 'days') != 0) {
          $scope.filtersChanged('date selector');
        }
      }
    }, true);

    //var today = moment();
    //var startWeek = moment().startOf('week').add('days',1);
    //$scope.startWeek = startWeek;

    var loadSavedFilters = function () {
      var storedFilters = {};
      var lastJobsFilters = {};
      if (sessionStorage.getItem('jobsLastFilters')) {
        lastJobsFilters = JSON.parse(sessionStorage.getItem('jobsLastFilters'));
      }
      if (sessionStorage.getItem('filters')) {
        storedFilters = JSON.parse(sessionStorage.getItem('filters'));

        if (storedFilters.order && storedFilters.order.id) {
          $scope.filters.order = storedFilters.order;
        }
        // if url param has order - override stored filter order
        if ($stateParams.orderId != null) {
          $scope.filters.order = { id: $stateParams.orderId };
          if ($stateParams.orderNumber != null) {
            $scope.filters.order.orderNumber = $stateParams.orderNumber;
          }
        }
        if (storedFilters.startDate != null) {
          $scope.filters.startDate = moment(storedFilters.startDate).toDate();
          $scope.dateFilterModel.dateStart = $scope.filters.startDate;
        }
        if (storedFilters.endDate != null) {
          $scope.filters.endDate = moment(storedFilters.endDate).toDate();
          $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
        }
        if (storedFilters.customerContact != null) {
          $scope.filters.customerContact = storedFilters.customerContact;
        }
        if (storedFilters.supplierContact != null) {
          $scope.filters.supplierContact = storedFilters.supplierContact;
        }
        if (storedFilters.forwarderContact != null) {
          $scope.filters.forwarderContact = storedFilters.forwarderContact;
        } else if (lastJobsFilters && lastJobsFilters.forwarderContact) {
          $scope.filters.forwarderContact = lastJobsFilters.forwarderContact;
        }
        if (storedFilters.jobNumber != null) {
          $scope.filters.jobNumber = storedFilters.jobNumber;
        } else if (lastJobsFilters && lastJobsFilters.jobNumber) {
          $scope.filters.jobNumber = lastJobsFilters.jobNumber;
        }
        if (storedFilters.reloadRequired) {
          $scope.filters.reloadRequired = storedFilters.reloadRequired;
        }
        // status filters
        if (storedFilters.statusOptions) {
          for (var i = 0; i < statusFilterOptions.length; i++) {
            if (storedFilters.statusOptions[statusFilterOptions[i]] == true) {
              $scope.filters.statusOptions[statusFilterOptions[i]] = true;
            } else {
              $scope.filters.statusOptions[statusFilterOptions[i]] = false;
            }
          }
          if (storedFilters.statusOptions.all == true) {
            $scope.filters.statusOptions.all = true;
            for (var i = 0; i < statusFilterOptions.length; i++) {
              $scope.filters.statusOptions[statusFilterOptions[i]] = true;
            }
          } else {
            $scope.filters.statusOptions.all = false;
          }
        }
        // if state params status is set - uisref status has been used and overrite status statusOptions
        if ($stateParams.status != undefined) {
          $scope.filters.statusOptions.all = false;
          for (var i = 0; i < statusFilterOptions.length; i++) {
            $scope.filters.statusOptions[statusFilterOptions[i]] = false;
          }
          $scope.filters.statusOptions[$stateParams.status] = true;
        }
        // assignee status filters
        if (lastJobsFilters.assigneeStatusOptions) {
          for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
            if (lastJobsFilters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] == true) {
              $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
            } else {
              $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
            }
          }
          if (lastJobsFilters.assigneeStatusOptions.all == true) {
            $scope.filters.assigneeStatusOptions.all = true;
            for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
              $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
            }
          } else {
            $scope.filters.assigneeStatusOptions.all = false;
          }
        }
        // if state params assigneeStatus is set - uisref status has been used and overrite status statusOptions
        if ($stateParams.assigneeStatus != undefined) {
          $scope.filters.assigneeStatusOptions.all = false;
          for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
            $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
          }
          $scope.filters.assigneeStatusOptions[$stateParams.assigneeStatus] = true;
        }
        // to hook up properly - allocate view type filters
        if (storedFilters.viewType != null && storedFilters.jobId == null) {
          $scope.filters.viewType = storedFilters.viewType;
        }
        if ($scope.filters.viewType == 'allocate') {
          if (storedFilters.startDate && storedFilters.endDate) {
            $scope.filters.startDate = moment($scope.filters.startDate).startOf('week').add('days', 1).toDate();
            $scope.dateFilterModel.dateStart = $scope.filters.startDate;
            $scope.filters.endDate = moment($scope.filters.startDate).add('days', 6).toDate();
          }
          if ($scope.filters.endDate == null) {
            $scope.filters.endDate = moment().add('days', 6).toDate();
            $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
          }
          if ($scope.filters.startDate == null) {
            $scope.filters.startDate = moment().startOf('week').add('days', 1).toDate();
            $scope.dateFilterModel.dateStart = $scope.filters.startDate;
          }
        }
        // load in most recent query params
        if (sessionStorage.getItem('jobsQuery') != null && sessionStorage.getItem('jobsQuery') != "undefined") {
          var queryStored = JSON.parse(sessionStorage.getItem('jobsQuery'));
          if (queryStored != null) {
            if (queryStored.limit) {
              $scope.query.limit = queryStored.limit;
            }
            if (queryStored.page) {
              $scope.query.page = queryStored.page;
            }
            if (queryStored.order) {
              $scope.query.order = queryStored.order;
            }
          }
        }
      }
      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    }

    loadSavedFilters();

    /**** Job Allocations Specific Handlers *****/

    $scope.loadUsers = function (cb) {
      userService.getMembers(null, function (users) {
        $scope.allUsers = users;
        $scope.allocationUsers = users;
        cb();
      }, function (err) {
        $scope.allUsers = [];
        $scope.allocationUsers = [];
        cb();
      });
    }

    /*** New Status Filters Helpers ***/

    $scope.prettifyFilterStatusPreview = function () {
      var output = "";

      if ($scope.filters.statusOptions.all) {
        return "All";
      }

      var soFar = 0;
      if ($scope.filters.statusOptions.draft) {
        soFar += 1;
        output += "Draft";
      }
      if ($scope.filters.statusOptions.sent) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Sent";
      }
      if ($scope.filters.statusOptions.closed) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Closed";
      }
      if (soFar == 0) {
        output += "None selected";
      }
      return output;
    }

    $scope.prettifyAssigneeFilterStatusPreview = function () {
      var output = "";

      if ($scope.filters.assigneeStatusOptions.all) {
        return "All";
      }

      var soFar = 0;
      if ($scope.filters.assigneeStatusOptions.assigned) {
        soFar += 1;
        output += "Assigned";
      }
      if ($scope.filters.assigneeStatusOptions.accepted) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Accepted";
      }
      if ($scope.filters.assigneeStatusOptions.rejected) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Rejected";
      }
      if (soFar == 0) {
        output += "None selected";
      }
      return output;
    }

    $scope.statusFiltersChanged = function () {
      var selectedCount = 0;
      for (var option in statusFilterOptions) {
        if ($scope.filters.statusOptions[statusFilterOptions[option]]) {
          selectedCount += 1;
        }
      }
      if (selectedCount == statusFilterOptions.length) {
        $scope.filters.statusOptions.all = true;
      } else {
        $scope.filters.statusOptions.all = false;
      }
      if (!$scope.preventReloadWithFilters) {
        $scope.filtersChanged('status options');
      }
    };

    $scope.assigneeStatusFiltersChanged = function () {
      var selectedCount = 0;
      for (var option in assigneeStatusFilterOptions) {
        if ($scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[option]]) {
          selectedCount += 1;
        }
      }
      if (selectedCount == assigneeStatusFilterOptions.length) {
        $scope.filters.assigneeStatusOptions.all = true;
      } else {
        $scope.filters.assigneeStatusOptions.all = false;
      }
      if (!$scope.preventReloadWithFilters) {
        $scope.filtersChanged('assignee status options');
      }
    };

    $scope.swapStatusFilter = function (option) {
      if (option == 'all' && $scope.filters.statusOptions.all == false) {
        for (var i in statusFilterOptions) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = true;
        }
        $scope.filters.statusOptions.allView = true;
        $scope.filters.statusOptions.all = true;
      } else if (option == 'all' && $scope.filters.statusOptions.all == true) {
        for (var i in statusFilterOptions) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        }
        $scope.filters.statusOptions.allView = false;
        $scope.filters.statusOptions.all = false;
      }
      $scope.statusFiltersChanged();
    }

    $scope.swapAssigneeStatusFilter = function (option) {
      if (option == 'all' && $scope.filters.assigneeStatusOptions.all == false) {
        for (var i in assigneeStatusFilterOptions) {
          $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
        }
        $scope.filters.assigneeStatusOptions.allView = true;
        $scope.filters.assigneeStatusOptions.all = true;
      } else if (option == 'all' && $scope.filters.assigneeStatusOptions.all == true) {
        for (var i in assigneeStatusFilterOptions) {
          $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
        }
        $scope.filters.assigneeStatusOptions.allView = false;
        $scope.filters.assigneeStatusOptions.all = false;
      }
      $scope.assigneeStatusFiltersChanged();
    }

    $scope.setOnlyFilter = function (option) {
      $scope.filters.statusOptions.all = false;
      for (var i in statusFilterOptions) {
        if (statusFilterOptions[i] != option) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        } else {
          $scope.filters.statusOptions[statusFilterOptions[i]] = true;
        }
      }
      $scope.statusFiltersChanged();
    }

    $scope.setAssigneeOnlyFilter = function (option) {
      $scope.filters.assigneeStatusOptions.all = false;
      for (var i in assigneeStatusFilterOptions) {
        if (assigneeStatusFilterOptions[i] != option) {
          $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
        } else {
          $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
        }
      }
      $scope.assigneeStatusFiltersChanged();
    }

    /**** New Filters for Job Allocations View ****/

    $scope.swapViewType = function () {
      if ($scope.filters.viewType == 'allocate') {
        $scope.filters.viewType = 'list';
        // set filters to show this current week from the allocate view
        //$scope.filters.startDate = moment($scope.filters.startDate).startOf('week').add('days',1).toDate();
        //$scope.filters.endDate = moment($scope.filters.startDate).add('days', 6).toDate();
        $scope.dateFilterModel.dateStart = $scope.filters.startDate;
        $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
        $scope.filtersChanged('viewswap');
      } else {
        $scope.filters.viewType = 'allocate';
        var startWeek = moment($scope.filters.startDate).startOf('week').add('days', 1);
        $scope.filters.startDate = startWeek.toDate();
        $scope.filters.endDate = startWeek.add('days', 6).toDate();
        $scope.filtersChanged('viewswap');
      }
    }

    // Allocations filter go back a week
    $scope.jobAllocationsFiltersBackWeek = function () {
      $scope.filters.startDate = moment($scope.filters.startDate).subtract('week', 1).toDate();
      $scope.filters.endDate = moment($scope.filters.endDate).subtract('week', 1).toDate();
      $scope.filtersChanged('backweek');
    }

    // Allocations filter go forward a week
    $scope.jobAllocationsFiltersNextWeek = function () {
      $scope.filters.startDate = moment($scope.filters.startDate).add('week', 1).toDate();
      $scope.filters.endDate = moment($scope.filters.endDate).add('week', 1).toDate();
      $scope.filtersChanged('nextweek');
    }

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    /************************************/
    /***** Job Detail View Controls *****/
    /************************************/

    var openJob = function (job) {
      $scope.currentJob = job;
      $scope.jobLoadingError = null;
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.minimiseList();
      $scope.prepareForJobFromParent(null, job.jobNumber);
      jobService.getJob(job, function (jobFull) {
        // setup line item quantities
        for (var i = 0; i < jobFull.lineItems.length; i++) {
          if (jobFull.lineItems[i].resource.uom.isTime) {
            var quantity = jobFull.lineItems[i].quantity;
            var hours = Math.floor(quantity / 60);
            var minutes = quantity % 60;
            jobFull.lineItems[i].quantityHoursEdit = hours;
            jobFull.lineItems[i].quantityMinutesEdit = minutes;
          } else {
            jobFull.lineItems[i].quantityEdit = jobFull.lineItems[i].quantity;
          }
        }

        if (accessControl.userHasPermission('io.docketbook.ojdapi.getOrder') && jobFull.orderRef != null) {
          orderService.getOrder(jobFull.orderRef, function (orderFull) {
            jobFull.orderRef = orderFull;
            $scope.lastCleanJob = angular.copy(jobFull);
            $scope.loadJobFromParent(jobFull);
            return;
          }, function (err) {
            if (jobFull.order != null) {
              var newOrderRef = {};
              newOrderRef.id = jobFull.order.orderId;
              newOrderRef.orderNumber = jobFull.order.orderNumber;
              jobFull.orderRef = newOrderRef;
            }
            $scope.lastCleanJob = angular.copy(jobFull);
            $scope.loadJobFromParent(jobFull);
            return;
          });
        } else {
          if (jobFull.order != null) {
            var newOrderRef = {};
            newOrderRef.id = jobFull.order.orderId;
            newOrderRef.orderNumber = jobFull.order.orderNumber;
            jobFull.orderRef = newOrderRef;
          }
        }

        $scope.lastCleanJob = angular.copy(jobFull);
        $scope.loadJobFromParent(jobFull);
      }, function (err) {
        $scope.jobLoadingErrorFull = err;
        $scope.jobLoadingError = "Error Getting Job";
      });
    }

    $scope.openJobAllocation = function (job) {
      if ($scope.filters.viewType == 'allocate') {
        $scope.swapViewType();
      }
      $scope.openJobDesktop(job, false);
    }

    $scope.openJobDesktop = function (job, skipDiffCheck) {
      var currentJob = $scope.getJobFromParent();
      var jobId = job;
      if (jobId.id != null) {
        jobId = jobId.id;
      }
      if (currentJob && currentJob.id == jobId) {
        return;
      }
      if (currentJob != null && currentJob.editing && !skipDiffCheck) {
        jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveJob(currentJob, function () {
                  if ($scope.currentOrg) {
                    $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
                  } else {
                    $state.go('main.jobDetail', { jobId: jobId });
                  }
                });
              } else if (actionSelected == 'dontSave') {
                if ($scope.currentOrg) {
                  $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
                } else {
                  $state.go('main.jobDetail', { jobId: jobId });
                }
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            if ($scope.currentOrg) {
              $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
            } else {
              $state.go('main.jobDetail', { jobId: jobId });
            }
          }
        });
      } else {
        if ($scope.currentOrg) {
          $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
        } else {
          $state.go('main.jobDetail', { jobId: jobId });
        }
      }
    }

    var closeJob = function () {
      $scope.splitListFunc.slideTableListDetailClosed();
      $scope.maximiseList();
      $scope.clearJobFromParent();
    }

    $scope.closeJobDesktop = function (skipDiff) {
      if (skipDiff && skipDiff == true) {
        if ($scope.currentOrg) {
          $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else {
          $state.go('main.jobs');
        }
        return;
      }
      // get diff and check if any changes first
      var currentJob = $scope.getJobFromParent();
      jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveJob(currentJob, function () {
                if ($scope.currentOrg) {
                  $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  $state.go('main.jobs');
                }
              });
            } else if (actionSelected == 'dontSave') {
              if ($scope.currentOrg) {
                $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                $state.go('main.jobs');
              }
            } else {
              // do nothing - stay where we are
            }
          });
          return;
        } else {
          if ($scope.currentOrg) {
            $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          } else {
            $state.go('main.jobs');
          }
        }
      });
    }

    $scope.assigneeChangeStatus = function (job, statusTo) {
      if (statusTo.toLowerCase() == 'rejected') {
        // check if assignee has any dockets created for this job
        var authoredDocketsCount = 0;
        for (var i = 0; i < job.dockets.length; i++) {
          if (job.dockets[i].author == $scope.currentUser.id) {
            authoredDocketsCount += 1;
          }
        }
        if (authoredDocketsCount > 0) {
          $scope.alertService.presentAutoAlert('rejectJobWithDockets', { status: 400 });
          return;
        }
        swal({
          title: "Reject Job " + job.jobNumber,
          text: "Please provide a reason for rejecting this job.",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: true,
          inputPlaceholder: "Reason"
        }, function (inputValue) {
          if (inputValue === false) {
            return;
          }
          jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, inputValue, function (success) {
            // status change successful - reload jobs list
            $scope.showToast('Job Status Updated');
            openJob(job);
          }, function (err) {
            $scope.alertService.presentAutoAlert('jobStatusChange', err);
          });
        });
      } else {
        jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, null, function (success) {
          // status change successful - reload jobs list
          $scope.showToast("Job Status Updated");
          openJob(job);
        }, function (err) {
          $scope.alertService.presentAutoAlert('jobStatusChange', err);
        });
      }
    }

    var newJob = function (fromOrder) {
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.minimiseList();
      $scope.lastCleanJob = {};
      $scope.newJobFromParent(fromOrder);
    }

    $scope.newJob = function (fromOrder) {
      if ($scope.filters.viewType == 'allocate') {
        $scope.swapViewType();
      }
      var currentJob = $scope.getJobFromParent();
      if (currentJob != null && currentJob.editing) {
        jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveJob(currentJob, function () {
                  $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
                });
              } else if (actionSelected == 'dontSave') {
                $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
              } else {
                // do nothing - stay where we are
              }
            });
            return;
          } else {
            $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
          }
        });
      } else {
        $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
      }
    }

    var newJobFromDuplicate = function (jobFrame) {
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.minimiseList();
      $scope.lastCleanJob = {};
      $scope.loadJobFromParent(jobFrame, true);
    }

    $scope.newJobFromDuplicate = function (jobFrame) {
      var currentJob = $scope.getJobFromParent();
      if (currentJob != null && currentJob.editing) {
        jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveJob(currentJob, function () {
                  newJobFromDuplicate(jobFrame);
                });
              } else if (actionSelected == 'dontSave') {
                newJobFromDuplicate(jobFrame);
              } else {
                // do nothing - stay where we are
              }
            });
            return;
          } else {
            newJobFromDuplicate(jobFrame);
          }
        });
      } else {
        newJobFromDuplicate(jobFrame);
      }
    }

    $scope.saveJob = function (job, cb) {
      var newJob = false;
      if (job.id == null) {
        newJob = true;
      }

      job.loading = true;
      job.loadingType = "saving";
      jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
        if (diffCount > 0 || newJob == true) {
          jobService.saveJob(diff, function (jobUpdated) {
            if (!cb) {
              openJob(jobUpdated, true);
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            } else {
              cb();
            }
          }, function (err) {
            job.loading = false;
            $scope.alertService.presentAutoAlert('saveJob', err);
          });
        } else {
          if (newJob) {
            $scope.showToast('New Job Saved');
          } else {
            $scope.showToast('Job Changes Saved');
          }
          if (!cb) {
            openJob(job, true);
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          } else {
            cb();
          }
        }
      });
    }

    $scope.removeJobFromCachedList = function (job) {
      var jobsListParsed = JSON.parse(sessionStorage.getItem('jobsList'));
      if (jobsListParsed) {
        var newList = [];
        for (var i = 0; i < jobsListParsed.length; i++) {
          if (jobsListParsed[i].id != job.id) {
            newList.push(jobsListParsed[i]);
          }
        }
        sessionStorage.setItem('jobsList', JSON.stringify(newList));
      }
    }

    $scope.deleteJob = function (job) {
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete this job?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          $scope.removeJobFromCachedList(job);
          jobService.deleteJob(job, function () {
            if ($scope.currentOrg) {
              $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              $state.go('main.jobs');
            }
          }, function (err) {
            $scope.alertService.presentAutoAlert('deleteJob', err);
          });
        }
      });
    }

    $scope.editJob = function (job) {
      job.editing = true;
    }

    $scope.cancelEditJob = function (job) {
      if (job.status == "New") {
        $scope.closeJobDesktop(job)
      } else {
        openJob(job);
      }
    }

    $scope.sendJob = function (job) {
      // Check if job is valid before attempting to do send
      jobService.validateSendJob(job, function () {
        jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
          if (diffCount > 0) {
            diff.status = 'sent';
            jobService.saveJob(diff, function (jobUpdated) {
              openJob(jobUpdated, true);
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            }, function (err) {
              job.loading = false;
              $scope.alertService.presentAutoAlert('sendJob', err);
            });
          } else {
            jobService.sendJob(job, function () {
              openJob(job, true);
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            }, function (err) {
              job.loading = false;
              $scope.alertService.presentAutoAlert('sendJob', err);
            });
          }
        });
      }, function (exceptions) {
        job.loading = false;
        $scope.alertService.presentAutoValidationAlert('sendJob', exceptions);
      });
    }

    $scope.closeJob = function (job) {
      jobService.closeJob(job, function () {
        openJob(job, true);
        if ($scope.filters.viewType == 'allocate') {
          $scope.loadJobAllocationsList();
        } else {
          $scope.loadJobsList();
        }
      }, function (err) {
        job.loading = false;
        $scope.alertService.presentAutoAlert('closeJob', err);
      });
    }

    $scope.duplicateJob = function (job) {
      var jobCopy = angular.copy(job);

      var newJobFrame = {};
      newJobFrame.status = "New";
      newJobFrame.statusDisplay = "New";
      newJobFrame.jobNumber = "New Job";
      newJobFrame.orderRef = jobCopy.orderRef;
      newJobFrame.order = jobCopy.orderRef;
      newJobFrame.customerContact = jobCopy.customerContact;
      newJobFrame.supplierContact = jobCopy.supplierContact;
      newJobFrame.fromAddress = jobCopy.fromAddress;
      newJobFrame.toAddress = jobCopy.toAddress;
      newJobFrame.instructions = jobCopy.instructions;
      newJobFrame.assignees = [];
      newJobFrame.accessControl = {};
      newJobFrame.editing = true;
      newJobFrame.organisation = jobCopy.organisation;
      newJobFrame.organisationGroup = jobCopy.organisationGroup;
      if (jobCopy.assignees) {
        for (var i = 0; i < jobCopy.assignees.length; i++) {
          var assignee = jobCopy.assignees[i];
          if ((assignee.organisation) && (assignee.organisation !== $scope.currentOrg.id)
            || (assignee.organisationGroup) && (assignee.organisationGroup !== $scope.currentOrgGroup.id)) {
            continue;
          }
          //verify that this assignee is part of the current org/org group context
          jobCopy.assignees[i].status = 'Assigned';
          newJobFrame.assignees.push(jobCopy.assignees[i]);
        }
      }
      // copy accessControl items that are forwarders
      var accessControlKeys = Object.keys(jobCopy.accessControl);
      for (var i = 0; i < accessControlKeys.length; i++) {
        if (jobCopy.accessControl[accessControlKeys[i]].indexOf('forwarder') != -1) {
          // this is a forwarder organisation - needs to be added to the new jobs accessControl list
          newJobFrame.accessControl[accessControlKeys[i]] = { 'add': ['forwarder'] };
        }
      }
      newJobFrame.lineItems = jobCopy.lineItems;
      for (var i = 0; i < newJobFrame.lineItems.length; i++) {
        delete newJobFrame.lineItems[i].id;
      }

      $scope.newJobFromDuplicate(newJobFrame);
    }

    /********************************/
    /**** Dockets Lists / Detail ****/
    /********************************/

    $scope.newDocketForJob = function (job) {
      if (!$scope.currentOrg) {
        return;
      }
      jobService.validateCreateDocket(job, function () {
        if (job != null && job.editing) {
          jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
            if (diffCount > 0) {
              var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
              $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
                if (actionSelected == 'save') {
                  $scope.saveJob(job, function () {
                    $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                  });
                } else if (actionSelected == 'dontSave') {
                  $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  // do nothing - stay where we are
                }
              });
            } else {
              $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            }
          });
        } else {
          $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      }, function (exceptions) {
        job.loading = false;
        $scope.alertService.presentAutoValidationAlert('jobCreateDocket', exceptions);
      });
    }

    $scope.docketsListForJob = function (job) {
      var currentJob = $scope.getJobFromParent();
      if (currentJob != null && currentJob.editing) {
        jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveJob(job, function () {
                  if ($scope.currentOrg) {
                    $state.go('main.groupDockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                  } else {
                    $state.go('main.dockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber });
                  }
                });
              } else if (actionSelected == 'dontSave') {
                if ($scope.currentOrg) {
                  $state.go('main.groupDockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  $state.go('main.dockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber });
                }
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            if ($scope.currentOrg) {
              $state.go('main.groupDockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              $state.go('main.dockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber });
            }
          }
        });
      } else {
        if ($scope.currentOrg) {
          $state.go('main.groupDockets', { jobId: job.id, jobNumber: job.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else {
          $state.go('main.dockets', { jobId: job.id, jobNumber: job.jobNumber });
        }
      }
    }

    /*****************************/
    /***** Job List Controls *****/
    /*****************************/

    $scope.filtersChanged = function (from) {
      if (!$scope.preventReloadWithFilters) {
        // check toDate is after fromDate
        if (moment($scope.filters.endDate).isBefore($scope.filters.startDate)) {
          $scope.filters.endDate = $scope.filters.startDate;
        }

        // check if status filter has changed
        //var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
        //if ( storedFilters.status != $scope.filters.status ) {
        //$scope.query.page = 1;
        //}
        $scope.query.page = 1;
        if ($scope.filters.viewType == 'allocate') {

          $scope.loadJobAllocationsList();
        } else {
          $scope.loadJobsList();
        }

        sessionStorage.setItem('filters', JSON.stringify($scope.filters));
      } else {
      }
    }

    /*$scope.jobsAllocationViewReady = function() {
      // check stateParams for any filter presets
      if ( $stateParams.orderId != null ) {
        $scope.filters.order = { id : $stateParams.orderId };
        if ( $stateParams.orderNumber != null ) {
          $scope.filters.order.orderNumber = $stateParams.orderNumber;
        }
      }
      if ( $stateParams.startDate != null ) {
        $scope.filters.startDate = moment($stateParams.startDate).toDate();
      }
      if ( $stateParams.endDate != null ) {
        $scope.filters.endDate = moment($stateParams.endDate).toDate();
      }
      if ( $stateParams.customerContact != null ) {
        $scope.filters.customerContact = $stateParams.customerContact;
      }
      if ( $stateParams.supplierContact != null ) {
        $scope.filters.supplierContact = $stateParams.supplierContact;
      }
      if ( $stateParams.forwarderContact != null ) {
        $scope.filters.forwarderContact = $stateParams.forwarderContact;
      }
      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
      $scope.loadJobAllocationsList();
    }*/

    $scope.jobsChildControllerReady = function () {
      // check stateParams for any filter presets
      if ($scope.currentOrg && sessionStorage.getItem('jobsList') != undefined) {
        // check if last stored jobs filters is the same as current filters
        var lastJobsFilters = {};
        if (sessionStorage.getItem('jobsLastFilters')) {
          lastJobsFilters = JSON.parse(sessionStorage.getItem('jobsLastFilters'));
        }
        var loadNew = false;
        if (sessionStorage.getItem('filters')) {
          var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
          if (storedFilters.reloadRequired == true) {
            loadNew = true;
            $scope.filters.reloadRequired = false;
          }
        }
        if (lastJobsFilters && lastJobsFilters != undefined) {
          if (lastJobsFilters.organisationId != $scope.currentOrg.id || lastJobsFilters.groupId != $scope.currentOrgGroup.id) {
            loadNew = true;
            $scope.filters.order = null;
          }
          if (lastJobsFilters.startDate && moment(lastJobsFilters.startDate).diff(moment($scope.filters.startDate), 'days') != 0) {
            loadNew = true;
          } else if (lastJobsFilters.endDate && moment(lastJobsFilters.endDate).diff(moment($scope.filters.endDate), 'days') != 0) {
            loadNew = true;
          }
          // check if status options have changed
          if (lastJobsFilters.statusOptions.all == true && $scope.filters.statusOptions.all != true) {
            loadNew = true;
          } else {
            for (var i = 0; i < statusFilterOptions.length; i++) {
              if (lastJobsFilters.statusOptions[statusFilterOptions[i]] != $scope.filters.statusOptions[statusFilterOptions[i]]) {
                loadNew = true;
              }
            }
          }
          if (lastJobsFilters.customerContact && !$scope.filters.customerContact) {
            loadNew = true;
          } else if (!lastJobsFilters.customerContact && $scope.filters.customerContact) {
            loadNew = true;
          } else if (!lastJobsFilters.customerContact && !$scope.filters.customerContact) {
            // do nothing
          } else if (lastJobsFilters.customerContact.id != $scope.filters.customerContact.id) {
            loadNew = true;
          }
        } else {
          // no previous filters stored, load new list
          loadNew = true;
        }
        // check if order has changed
        if (lastJobsFilters.order && !$scope.filters.order) {
          loadNew = true;
        } else if (!lastJobsFilters.order && $scope.filters.order) {
          loadNew = true;
        } else if (!lastJobsFilters.order && !$scope.filters.order) {
          // do nothing
        } else if (lastJobsFilters.order.id != $scope.filters.order.id) {
          loadNew = true;
        }

        if (loadNew) {
          $scope.query.page = 1;
          $scope.loadJobsList();
        } else {
          var jobsListParsed = JSON.parse(sessionStorage.getItem('jobsList'));
          var jobsListCount = JSON.parse(sessionStorage.getItem('jobsListCount'));
          $scope.loadJobsListFromParent(jobsListParsed, jobsListCount);
          $scope.preventReloadWithFilters = false;
        }
      } else {
        $scope.loadJobsList();
      }
    }

    $scope.detailControllerReady = function () {
      if ($stateParams.jobId != null) {
        if ($stateParams.jobId == 'new') {
          if ($stateParams.fromOrder != null) {
            newJob($stateParams.fromOrder);
          } else {
            newJob();
          }
        } else {
          openJob($stateParams.jobId);
        }
      }
    }

    $scope.loadJobsList = function (searchValue, reload) {
      $scope.selected = [];
      $scope.promise = $q(function (resolve, reject) {
        var params = $scope.getFilterParams();
        params['limit'] = $scope.query.limit;
        params['offset'] = $scope.query.limit * ($scope.query.page - 1);
        params['sort'] = $scope.query.order;

        if (searchValue != null && searchValue != "") {
          params['search'] = searchValue;
        }

        jobService.getJobs(params, function (returnData) {
          var jobsListParsed = jobService.parseJobs(returnData);
          var count = 0;
          if (params.offset <= 0 && returnData.length < params.limit) {
            count = returnData.length;
          } else {
            count = params.offset + (params.limit + 1);
          }
          $scope.loadJobsListFromParent(jobsListParsed, count);
          if (reload && reload == true) {
            var currentJob = $scope.getJobFromParent();
            if (currentJob && !currentJob.editing && currentJob.id != null) {
              openJob(currentJob.id);
            }
          }
          $scope.preventReloadWithFilters = false;
          // store list in sessionStorage
          sessionStorage.setItem('jobsList', JSON.stringify(jobsListParsed));
          sessionStorage.setItem('jobsListCount', count);
          sessionStorage.setItem('jobsQuery', JSON.stringify($scope.query));
          sessionStorage.setItem('filters', JSON.stringify($scope.filters));
          sessionStorage.setItem('jobsLastFilters', JSON.stringify($scope.filters));
          resolve('Done');
        }, function (err) {
          reject('error');
        });
      });
    }

    $scope.loadJobAllocationsList = function (searchValue, reload) {
      $scope.promise = $q(function (resolve, reject) {
        $scope.allocationUsers = [];
        var params = $scope.getFilterParams()
        //params['limit'] = '500';
        //params['offset'] = $scope.query.limit * ($scope.query.page - 1);
        //params['sort'] = 'startDate';


        if (searchValue != null && searchValue != "") {
          params['search'] = searchValue;
        }

        var fromDateBeforeConvert = moment(params.endFromDate, 'YYYY-MM-DD');
        params.endFromDate = fromDateBeforeConvert.subtract('days', 1).format('YYYY-MM-DD');
        var toDateBeforeConvert = moment(params.startToDate, 'YYYY-MM-DD');
        params.startToDate = toDateBeforeConvert.add('days', 1).format('YYYY-MM-DD');

        jobService.getJobs(params, function (returnData) {
          var jobsListParsed = jobService.parseJobs(returnData);
          var count = 0;
          if (params.offset <= 0 && returnData.length < params.limit) {
            count = returnData.length;
          } else {
            count = params.offset + (params.limit + 1);
          }
          var jobAllocationsByUser = {};
          for (var i = 0; i < returnData.length; i++) {
            var thisJob = returnData[i];
            // check if this job lies within this week
            if ((moment(thisJob.endDate, 'YYYY-MM-DD').diff(moment($scope.filters.startDate)) >= 0 && moment(thisJob.startDate, 'YYYY-MM-DD').diff(moment($scope.filters.startDate).add('days', 6)) <= 0)) {
              for (var j = 0; j < thisJob.assignees.length; j++) {
                if (jobAllocationsByUser[thisJob.assignees[j].assignee] == null) {
                  jobAllocationsByUser[thisJob.assignees[j].assignee] = { maxOverlaps: 0, jobs: {}, startDays: { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }, intersectDays: { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }, jobVOffsets: {}, jobStatus: {}, jobRejectionComments: {} };
                }

                thisJob.displayVerticalOffset = 0;
                jobAllocationsByUser[thisJob.assignees[j].assignee].jobs[thisJob.id] = thisJob;
                jobAllocationsByUser[thisJob.assignees[j].assignee].jobVOffsets[thisJob.id] = 0;

                // find which day(s) this job is on
                var jobStartDay = moment(thisJob.startDate, 'YYYY-MM-DD').diff(moment($scope.filters.startDate), 'days') + 1;
                var jobEndDay = moment(thisJob.endDate, 'YYYY-MM-DD').diff(moment($scope.filters.startDate), 'days') + 1;
                if (jobStartDay < 1) {
                  jobStartDay = 1;
                }
                if (jobEndDay > 7) {
                  jobEndDay = 7;
                }
                thisJob.daysCovered = (jobEndDay - jobStartDay) + 1;

                jobAllocationsByUser[thisJob.assignees[j].assignee].startDays[jobStartDay].push(thisJob.id);

                for (var k = jobStartDay; k <= jobEndDay; k++) {
                  jobAllocationsByUser[thisJob.assignees[j].assignee].intersectDays[k].push(thisJob.id);
                }

                // get the status to display for the allocation item
                var status = thisJob.status;
                if (thisJob.status == 'Sent') {
                  // get the assignee status
                  status = thisJob.assignees[j].status;
                  if (status == 'Rejected') {
                    jobAllocationsByUser[thisJob.assignees[j].assignee].jobRejectionComments[thisJob.id] = thisJob.assignees[j].rejectionComment;
                  }
                } else if (thisJob.status == 'Draft') {
                  status = 'In Draft';
                }
                jobAllocationsByUser[thisJob.assignees[j].assignee].jobStatus[thisJob.id] = status;
              }
            }
          }
          // find intersects on days for each assignee and add offsets
          for (var assignee in jobAllocationsByUser) {
            for (var i = 1; i <= 7; i++) {
              for (var j = 0; j < jobAllocationsByUser[assignee].intersectDays[i].length; j++) {
                if (j > jobAllocationsByUser[assignee].jobVOffsets[jobAllocationsByUser[assignee].intersectDays[i][j]]) {
                  jobAllocationsByUser[assignee].jobVOffsets[jobAllocationsByUser[assignee].intersectDays[i][j]] = j;
                  if (jobAllocationsByUser[assignee].maxOverlaps < j) {
                    jobAllocationsByUser[assignee].maxOverlaps = j;
                  }
                }
              }
            }
          }
          $scope.jobAllocationsByUser = jobAllocationsByUser;

          // re-order users list by number of assignments
          var reorderedUsers = [];
          var unallocatedUsers = [];
          for (var i = 0; i < $scope.allUsers.length; i++) {
            if ($scope.jobAllocationsByUser[$scope.allUsers[i].id] && Object.keys($scope.jobAllocationsByUser[$scope.allUsers[i].id].jobs).length > 0) {
              reorderedUsers.push($scope.allUsers[i]);
            } else {
              unallocatedUsers.push($scope.allUsers[i]);
            }
          }
          for (var i = 0; i < unallocatedUsers.length; i++) {
            reorderedUsers.push(unallocatedUsers[i]);
          }
          $scope.allocationUsers = reorderedUsers;

          resolve('Done');
        }, function (err) {
          reject('error');
        });
      });
    }

    /*****************************/
    /***** List View Controls ****/
    /*****************************/

    $scope.selectContactFilter = function (type) {
      var existingContact = null;
      if (type == 'customer') {
        if ($scope.filters.customerContact != null) {
          existingContact = $scope.filters.customerContact;
        }
      } else if (type === 'forwarder') {
        if ($scope.filters.forwarderContact != null) {
          existingContact = $scope.filters.forwarderContact;
        }
      }
      $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
        if (contactSelected != null) {
          if (type == 'customer') {
            $scope.filters.customerContact = contactSelected;
          } else if (type === 'forwarder') {
            $scope.filters.forwarderContact = contactSelected;
          }
          $scope.filtersChanged(contactSelected);
        }
      });
    }

    $scope.selectOrderForJob = function (options, cb) {
      $scope.splitListFunc.ensureListOpen();
      $scope.selectOrderCallback = cb;
      $scope.orderSelectFromParent(options, function (orderSelected) {
        $scope.selectOrderCallback(orderSelected);
      });
    }

    $scope.selectOrderFilter = function () {
      var currentOrder = null;
      var options = {};
      if ($scope.filters.order != null) {
        options.currentOrder = $scope.filters.order;
      }
      $scope.orderSelectFromParent(options, function (orderSelected) {
        if (orderSelected != null) {
          $scope.filters.order = orderSelected;
          $scope.filtersChanged('order');
        }
      });
    }

    $scope.selectPersonForJob = function (assignedUsers, cb) {
      $scope.splitListFunc.ensureListOpen();
      $scope.selectPersonCallback = cb;
      $scope.desktopPeopleSelectFromParent(assignedUsers, function (peopleSelected) {
        $scope.selectPersonCallback(peopleSelected);
      });
    }

    $scope.selectLineFromOrder = function (sourceList, cb) {
      $scope.splitListFunc.ensureListOpen();
      $scope.selectLineCallback = cb;
      $scope.lineSelectFromParent(sourceList, function (linesSelected) {
        $scope.selectLineCallback(linesSelected, 'desktop');
      });
    }

    $scope.selectContactForJob = function (cb) {
      $scope.contactSelectFromParent(null, null, function (contactSelected) {
        cb(contactSelected);
      });
    }

    /***************************/
    /***** Job Data Helpers ****/
    /***************************/

    // Bulk Delete
    $scope.bulkSelectionDelete = function () {
      var itemsToDelete = $scope.selected;
      $scope.clearJobFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete these " + itemsToDelete.length + " jobs?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          jobService.deleteBulkJobs(itemsToDelete, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkJobs', { status: 202, requestName: 'Delete bulk jobs - failures ' + failures.length + ' of ' + itemsToDelete.length });
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkJobs', { status: 200 });
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            }
            $scope.selected = [];
          });
        }
      });
    }

    // Bulk Send
    $scope.bulkSelectionSend = function (confirmationText) {
      confirmationText = confirmationText ? confirmationText : 'send'
      var itemsToSend = $scope.selected;


      if (confirmationText == 're-open' && itemsToSend.filter(x => x.status != 'Closed').length > 0) {
        swal({
          type: 'warning',
          text: 'It looks like some of the jobs selected are not closed. Check your selection and try again.',
          title: 'Hold Tight!'
        })
        return
      }

      swal({
        title: "Are you sure?",
        text: `Do you really want to ${confirmationText} these ${itemsToSend.length} jobs?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: `Yes, ${confirmationText} them!`,
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          jobService.sendBulkJobs(itemsToSend, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('sendBulkJobs', { status: 202, requestName: 'Send bulk jobs - failures ' + failures.length + ' of ' + itemsToSend.length });
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            } else {
              $scope.alertService.presentAutoAlert('sendBulkJobs', { status: 200 });
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            }
            $scope.selected = [];
          });
        }
      });
    }

    // Bulk Close
    $scope.bulkSelectionClose = function () {
      var itemsToClose = $scope.selected;
      swal({
        title: "Are you sure?",
        text: "Do you really want to close these " + itemsToClose.length + " jobs?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, close them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          jobService.closeBulkJobs(itemsToClose, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('closeBulkJobs', { status: 202, requestName: 'Close bulk jobs - failures ' + failures.length + ' of ' + itemsToClose.length });
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            } else {
              $scope.alertService.presentAutoAlert('closeBulkJobs', { status: 200 });
              if ($scope.filters.viewType == 'allocate') {
                $scope.loadJobAllocationsList();
              } else {
                $scope.loadJobsList();
              }
            }
            $scope.selected = [];
          });
        }
      });
    }

    // Bulk Duplicate
    $scope.bulkSelectionDuplicate = function () {
      $scope.duplicateJobs = {};
      $scope.duplicateJobs.list = $scope.selected;
      $("#duplicateJobsModal").fadeIn(100);
    }

    $scope.closeDuplicateJobsModal = function () {
      $("#duplicateJobsModal").fadeOut(100);
    }

    $scope.duplicateJobsContinue = function () {
      // create new jobs for each in duplicates list with start and end date overwritten
      $scope.duplicateJobs.saving = true;
      var jobsToSave = [];

      for (var i = 0; i < $scope.duplicateJobs.list.length; i++) {
        var jobCopy = $scope.duplicateJobs.list[i];
        var newJobFrame = {};
        newJobFrame.status = "New";
        newJobFrame.statusDisplay = "New";
        newJobFrame.jobNumber = "New Job";
        if (jobCopy.orderRef) {
          newJobFrame.orderRef = jobCopy.orderRef;
        }
        if (jobCopy.customerContact) {
          newJobFrame.customerContact = angular.copy(jobCopy.customerContact);
        }
        if (jobCopy.supplierContact) {
          newJobFrame.supplierContact = angular.copy(jobCopy.supplierContact);
        }
        if (jobCopy.fromAddress) {
          newJobFrame.fromAddress = jobCopy.fromAddress;
        }
        if (jobCopy.toAddress) {
          newJobFrame.toAddress = jobCopy.toAddress;
        }
        if (jobCopy.instructions) {
          newJobFrame.instructions = jobCopy.instructions;
        }
        newJobFrame.assignees = [];
        newJobFrame.startDate = $scope.duplicateJobs.startDate;
        newJobFrame.endDate = $scope.duplicateJobs.endDate;
        if (jobCopy.assignees) {
          for (var j = 0; j < jobCopy.assignees.length; j++) {
            newJobFrame.assignees.push({ assignee: jobCopy.assignees[j].assignee, emailAddress: jobCopy.assignees[j].emailAddress, name: jobCopy.assignees[j].name, status: 'assigned' });
          }
        }
        if (jobCopy.lineItems) {
          newJobFrame.lineItems = angular.copy(jobCopy.lineItems);
        }
        jobsToSave.push(newJobFrame);
      }

      $scope.saveDuplicateJobs(jobsToSave, 0, [], function (jobsCreated) {
        $("#duplicateJobsModal").fadeOut(100);
        if ($scope.filters.viewType == 'allocate') {
          $scope.loadJobAllocationsList();
        } else {
          $scope.loadJobsList();
        }
      });
    }

    $scope.saveDuplicateJobs = function (jobsList, index, jobsCreated, cb) {
      if (index >= jobsList.length) {
        cb(jobsCreated);
        return;
      }

      jobService.saveJob(jobsList[index], function (savedJob) {
        jobsCreated.push(savedJob);
        $scope.saveDuplicateJobs(jobsList, index + 1, jobsCreated, cb);
      }, function (err) {
        $scope.saveDuplicateJobs(jobsList, index + 1, jobsCreated, cb);
      });
    }

    /***********************/
    /**** Job Comments *****/
    /***********************/

    $scope.addNewComment = function (job) {
      $("#jobCommentModal").fadeIn(100);
      $scope.newJobComment = {};
      $scope.newJobComment.comment = "";
      $scope.newJobComment.job = job;
    }

    $scope.closeJobCommentModal = function () {
      $("#jobCommentModal").fadeOut(100);
      $scope.newJobComment = {};
    }

    $scope.addCommentModalNext = function () {
      $scope.newJobComment.loading = true;
      $scope.addCommentToJob($scope.newJobComment.job, $scope.newJobComment.comment);
    }

    $scope.addCommentToJob = function (job, commentText) {
      if (!job.editing && job.userAssigneeData) {
        // add comment as an assignee
        jobService.addAssigneeComment(job, commentText, function (jobUpdated) {
          job.comments = jobUpdated.comments;
          $("#jobCommentModal").fadeOut(100);
        }, function (err) {
          $scope.newJobComment.loading = false;
          $scope.alertService.presentAutoAlert('addJobComment', err);
        });
      } else {
        var comment = {};
        comment.comment = commentText;
        comment.author = $scope.currentUser.id;
        comment.authorName = $scope.currentUser.name.full;
        comment.date = moment().toISOString();

        jobService.addComment(job, comment, function (jobUpdated) {
          job.comments = jobUpdated.comments;
          $("#jobCommentModal").fadeOut(100);
        }, function (err) {
          $scope.newJobComment.loading = false;
          $scope.alertService.presentAutoAlert('addJobComment', err);
        });
      }
    }

    $scope.removeCommentFromJob = function (job, comment) {
      jobService.deleteComment(job, comment, function (jobUpdated) {
        job.comments = jobUpdated.comments;
      }, function (err) {
        $scope.alertService.presentAutoAlert('removeJobComment', err);
      });
    }

    /********************/
    /***** Filters ******/
    /********************/

    $scope.getFilterParams = function () {
      var params = {};
      if ($scope.filters.endDate != null) {
        var startToDate = moment($scope.filters.endDate);
        params.startToDate = startToDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.startDate != null) {
        var endFromDate = moment($scope.filters.startDate);
        params.endFromDate = endFromDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.customer != 'All' && $scope.filters.customer != null) {
        params.customer = $scope.filters.customer;
      }
      if ($scope.filters.assignee != 'All' && $scope.filters.assignee != null) {
        if ($scope.filters.assignee == 'Me') {
          params.assignee = $scope.currentUser.id;
        } else {
          // generate uuid list of assignees
          var uuidList = [];
          for (var i = 0; i < $scope.filters.assigneeList.length; i++) {
            uuidList.push($scope.filters.assigneeList[i].id);
          }
          params.assignee = uuidList;
        }
      }
      if ($scope.filters.statusOptions.all == true) {
        params['status'] = null;
      } else {
        var statusParam = "";
        var count = 0;
        for (var i in statusFilterOptions) {
          if ($scope.filters.statusOptions[statusFilterOptions[i]] == true) {
            count += 1;
            if (count > 1) {
              statusParam += ", ";
            }
            statusParam += statusFilterOptions[i];
          }
        }
        params['status'] = statusParam;
      }
      if ($scope.filters.assigneeStatusOptions.all == true) {
        params['hasRejections'] = false;
      } else {
        var statusCount = 0;
        for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
          if ($scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] == true) {
            statusCount += 1;
          }
        }
        if ($scope.filters.assigneeStatusOptions.rejected == true && statusCount == 1) {
          params['hasRejections'] = true;
        }
      }
      // filtering by order
      if ($scope.filters.order != null && $scope.filters.order.id != null) {
        params.orderRef = $scope.filters.order.id;
      }
      if ($scope.filters.customerContact != null) {
        var customerAddresses = [];
        for (var i = 0; i < $scope.filters.customerContact.contactAddresses.length; i++) {
          customerAddresses.push($scope.filters.customerContact.contactAddresses[i].emailAddress);
        }
        params.customer = customerAddresses.join(',');
      }
      if ($scope.filters.jobNumber != null && $scope.filters.jobNumber != "") {
        params.jobNumber = $scope.filters.jobNumber;
      }
      if ($scope.filters.forwarderContact) {
        params.forwarders = $scope.filters.forwarderContact.contactAddresses.map((address) => {
          return address.emailAddress;
        }).join(',');
      }
      if ($scope.filters.hasRejections === true) {
        params.hasRejections = 'true';
      }
      return params;
    }

    $scope.resetAllFilters = function () {
      // SETUP filters
      $scope.filters = {};
      $scope.filters.status = 'All';
      $scope.filters.startDate = null;// moment().subtract(7,'days').toDate();
      $scope.filters.endDate = null;
      $scope.filters.customer = 'All';
      $scope.filters.assignee = 'All';
      $scope.filters.jobNumber = null;
      $scope.filters.assigneeList = [];
    }

    $scope.searchJobsChange = function (value) {
      if ($scope.filters.viewType == 'allocate') {
        $scope.loadJobAllocationsList();
      } else {
        $scope.loadJobsList();
      }
    }

    $scope.clearFilterItem = function (name) {
      $scope.filters[name] = null;
      $scope.filtersChanged(name);
    }

    $scope.clearFilters = function () {
      $scope.filters.order = null;
      $scope.filters.jobNumber = null;
      $scope.filters.customerContact = null;
      $scope.filters.forwarderContact = null;
      $scope.filters.hasRejections = false;
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
      $scope.filters.statusOptions.allView = true;
      $scope.filters.statusOptions.all = true;
      // reset date filters
      $scope.filters.startDate = moment().subtract(7, 'days').toDate(); //startFromDate
      $scope.filters.endDate = moment().toDate(); //endToDate
      $scope.dateFilterModel.dateStart = moment().subtract(7, 'days').toDate();
      $scope.dateFilterModel.dateEnd = moment().toDate();
      $scope.filtersChanged('cleared');
      window.location.reload();
    }

    $scope.clearFilterDateSet = function (firstDate, secondDate) {
      $scope.filters[firstDate] = null;
      $scope.filters[secondDate] = null;
    }

    $scope.toggleFilters = function () {
      $scope.showFilters = !$scope.showFilters;
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /*$scope.$watch('filters', function() {
      if ( !$scope.preventReloadWithFilters ) {
        if ( $scope.filters.viewType == 'allocation' ) {
          $scope.loadJobAllocationsList();
        }
      }
    },true);*/

    /* Currently Load Allocations Immediately */
    if ($scope.currentOrg != null) {
      $scope.loadUsers(function () {
        //$scope.jobsAllocationViewReady(
        if ($scope.filters.viewType == 'allocate') {
          $scope.loadJobAllocationsList();
        }
      });
    }

    $scope.showUpgradePlanModal = function (_, feature, trackingText) {
      $scope.selectPlan(null, feature, trackingText)
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/jobs/desktopController.js